export type VersionChangesEntry = {
    version: string;
    date: string;
    changes: string[];
};

export function getVersionReleaseNotesEntries(
    entries: VersionChangesEntry[] | undefined,
    version: string,
): VersionChangesEntry[] {
    return entries?.filter((entry) => entry.version === version) ?? [];
}

function getLatestVersionReleaseNotesEntry(
    entries: VersionChangesEntry[] | undefined,
    version: string,
): VersionChangesEntry | undefined {
    if (!entries?.length) {
        return undefined;
    }

    for (let index = entries.length - 1; index >= 0; index -= 1) {
        const entry = entries[index];
        if (entry.version === version) {
            return entry;
        }
    }

    return undefined;
}

export function getLatestVersionReleaseNotesChanges(entries: VersionChangesEntry[] | undefined, version: string): string[] {
    const entry = getLatestVersionReleaseNotesEntry(entries, version);
    return entry?.changes.filter((change) => change.trim() !== "") ?? [];
}

export function hasVersionReleaseNotesEntries(entries: VersionChangesEntry[]): boolean {
    return entries.some((entry) => entry.changes.some((change) => change.trim() !== ""));
}
